export default __webpack_public_path__ + "static/media/2058.2f178317.png";